import React, { useContext, useMemo, useRef } from "react";
import EmptyLayout from "layouts/empty-layout";
import TemplateTwoFullPageOne from "./full-preview/template-two/page-one";
import TemplateTwoFullPageTwo from "./full-preview/template-two/page-two";
import { Context } from "context/context";
import _ from "lodash";
import TemplateThreeFullPageOne from "./full-preview/template-three/page-one";
import TemplateThreeFullPageTwo from "./full-preview/template-three/page-two";
import TemplateFourFullPageTwo from "./full-preview/template-four/page-two";
import TemplateFourFullPageOne from "./full-preview/template-four/page-one";
import TemplateOneFull from "./full-preview/template-one";
import { sortMilestones } from "utils/utils";
import TemplateFiveFullPageOne from "./full-preview/template-five/page-one";
import TemplateFiveFullPageTwo from "./full-preview/template-five/page-two";
import { TEMPLATE_NAME_1,TEMPLATE_NAME_2, TEMPLATE_NAME_3, TEMPLATE_NAME_4,TEMPLATE_NAME_5 } from "constants/options";

import { groupArraysWithType,mergeArray,filterPrivateMilestones } from "./resume";
import { A4_SIZE } from "./resume";
import { applySharedBudget } from "utils/bio-limit";
import ItemMilestone, {ItemMilestoneClone} from "./preview/template-one-tg/item-milestone";
import { LeftContent } from "./full-preview/template-one";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useResume } from "redux/modules/resume/hooks";
import Lottie from "lottie-react";
import Spinner from "assets/json/spinner.json";
import { useModal } from "react-modal-hook"
import { useReactToPrint } from "react-to-print";


const LONG_SIZE = {
  width: "816px", // 8.5 inch
  maxWidth: "816px", // 8.5 
  // minHeight: "1248px", // 13 inch (1056px is 11 inch)
  minHeight: "1344px", // 13 inch (1056px is 11 inch)
};

export default function ResumeFullPreview(props) {
  const profile = JSON.parse(localStorage.getItem('user_data'))?.profile;
  const { state, milestones: rawMilestones, previewImage,setState,
      setMilestones,
      resetMilestones,
      setPreviewImage, } = useContext(Context);
  // Display-only: hide private milestones from the shared/PDF resume unless the
  // "Show Private Milestones" toggle is on. The saved selection (rawMilestones)
  // is untouched; every downstream use below reads this filtered view. (MCF-1827)
  const milestones = React.useMemo(
    () => filterPrivateMilestones(rawMilestones, state.show_private_milestone),
    [rawMilestones, state.show_private_milestone]
  );
  const [totalPage, setTotalPage] = React.useState(2)
  const {t} = useTranslation();
  const {link_id} = useParams();
  const { http } = global.services;
  const { updateResume, resumes } = useResume();
  // Cut the pooled text boxes (bio + Professional fields) to the template's
  // shared budget so the PDF/share page prints only what fits (MCF-637).
  let moreInfo = applySharedBudget(
    resumes.find(item => item.id === state.id)?.more_info || state?.more || {},
    state.templateName
  );

  const [primaryColor, secondaryColor, tertiaryColor, quarternary] =
    useMemo(() => {
      if (!_.isEmpty(state.color)) {
        return state.color.value;
      }
      return ["", "", "", ""];
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.color]);

    const [mergeMilestone, setMergeMilestone] = React.useState([]);
    const [sampleMerge,setMerge] = React.useState([]);
    const itemRefs = React.useRef([]);
    const [pageContents, setPageContents] = React.useState([]);
    const [showDisplay, setDisplay] = React.useState(false);
    const [showLoading, hideLoading] = useModal(() => <LoadingModal />);

    const measureItems = React.useCallback((sampleMerge) => {
      const newPageContents = [];
      let currentPage = [];
      let currentHeight = 0;
      if(state.templateName === TEMPLATE_NAME_5) return;

      // Milestone height budget per page. The page (A4) is 1123px tall, so the
      // old 1000px budget left a visible gap at the bottom. Lift it so one more
      // milestone fits per page while staying clear of the page footer.
      const PAGE_BUDGET = 1080;

      sampleMerge.forEach((item, index) => {
        const itemHeight = itemRefs.current[index]?.offsetHeight || 0;

        if (currentHeight + itemHeight > PAGE_BUDGET) {
          newPageContents.push(currentPage);
          currentPage = [];
          currentHeight = 0;
        }

        currentPage.push(item);
        currentHeight += itemHeight;
      });

      // The QR codes render on the final page, under the milestones. Don't add
      // the extra milestone to that page (client request): if the last page has
      // no room left for the QR block, push its last milestone onto a new page
      // so the QR always has space.
      const showQR = state.show_qr_milestone || state.show_qr_reels;
      const QR_BLOCK_HEIGHT = 200;
      if (showQR && currentPage.length > 1 && currentHeight + QR_BLOCK_HEIGHT > PAGE_BUDGET) {
        const moved = currentPage.pop();
        newPageContents.push(currentPage);
        currentPage = [moved];
      }

      if (currentPage.length > 0) {
        newPageContents.push(currentPage);
      }

      setPageContents(newPageContents);
      setTotalPage(newPageContents.length+1);

    },[state.templateName, state.show_qr_milestone, state.show_qr_reels]);

    React.useEffect(() => { 
      if(state.templateName === TEMPLATE_NAME_5) return;
      const arraysWithType = [
        { array: sortMilestones(milestones?.featured) || [], type: 'featured' },
        { array: sortMilestones(milestones?.current) || [], type: 'current' },
        { array: sortMilestones(milestones?.past) || [], type: 'past' },
      ];
      if(state.templateName !== TEMPLATE_NAME_1){
        let groupAll;
        switch(state.templateName){
          case TEMPLATE_NAME_2:
            groupAll = groupArraysWithType(arraysWithType,6,6);
            break;
          case TEMPLATE_NAME_3:
            groupAll = groupArraysWithType(arraysWithType,7,7);
            break;
          case TEMPLATE_NAME_4:
            groupAll = groupArraysWithType(arraysWithType,8,8);
            break;
          default:
            groupAll = groupArraysWithType(arraysWithType,6,6);
        }
        console.log("Check Merge")
        console.log(groupAll)
        setMergeMilestone(groupAll)
        setTotalPage(groupAll.length + 1) // plus 1 for the fist page this is only for the individual;
        return;
      }
        let merge = mergeArray(arraysWithType);
        measureItems(merge)
        setMerge(merge);  
    }, [milestones, state.templateName, setMerge, measureItems]);

    React.useEffect(()=>{
      if(state.templateName !== TEMPLATE_NAME_1){
        return;
      }
      if (itemRefs.current.length > 0 && itemRefs.current.every(ref => ref !== null)) {
        console.log("All items are loaded");
        setTimeout(measureItems(sampleMerge), 1);
        setTimeout(setDisplay(true), 1); 
      }else{
        // setDisplay(false);
      }
    },[pageContents,sampleMerge,measureItems,setDisplay,state.templateName])

     React.useEffect(() => {
      if (link_id) { //this is from copy link/ share link to display
          showLoading();
          console.log("Resume ID:", link_id);
          onNavigate(link_id)
        // fetch resume here
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [link_id]);

    const onNavigate = async(id) => {
        try{
          let response = null; 
          const { data } = await http.get(`public/resumes/${id}`);
          response = data;
          if(response){
            updateResume(data); 
            let position = response?.milestone_position || [];
            let resume_milestones = response?.resume_milestones || [];
            let info = {
              personal: response?.personal_info,
              more: response?.more_info,
              show_milestone_image: response?.show_milestone_image,
              show_private_milestone: response?.show_private_milestone ?? false,
              show_qr_milestone:response?.show_qr_milestone,
              show_qr_reels: response?.show_qr_reels,
              hideOccupation:[],
              milestone_position:position,
              template_url:response?.template_url || null
            };
      
            if (response?.social_media) {
              data.social = response?.social_media;
            }
            console.trace(data.social)
      
            if (response.personal_info.hasOwnProperty("profile_image")) {
              setPreviewImage(
                response.personal_info.profile_image || response?.profile_image_withURL 
              );
            } else {
              setPreviewImage("");
            }
      
            setState((prev) => ({
              ...prev,
              ...info,
              templateName: response.template_name,
              color: response.template_color,
              link_id: response.link_id,
              id: response.id,
            }));
      
            if (!_.isEmpty(resume_milestones)) {
              Object.keys(resume_milestones).forEach((key) => {
                const milestones = resume_milestones[key]?.map?.((m) => m.milestone);
                setMilestones((prev) => ({
                  ...prev,
                  [key]: milestones,
                }));
              });
            } else {
              resetMilestones();
            }
          }
    
        }catch(e){
          console.trace(e)
        }finally{
          hideLoading();
        }
        
      };

    const componentRef = useRef(null);
    const reactToPrintRef = useReactToPrint({
        documentTitle: 'Title',
        contentRef: componentRef,
    });
    const handlePrint = () => {
      if (!componentRef.current) {
        alert("Data is still loading, please wait!");
        return;
      }
      reactToPrintRef(); // call the useReactToPrint function
    };
    

  return (
    <EmptyLayout
      title={t('fullPreviewResume')}
      description={t('fullPreviewResume')}
      backButton={t('closePreview')}
      handlePrint = {handlePrint}
      showDowload = {true}
      showClosePrev = {link_id ? true : false}
      >
      <div className="w-full h-full grid bg-default justify-center py-5 gap-y-5 overflow-y-auto custom-scroll">
        <>
          <div
            className="w-full h-full relative">
            {state.templateName === TEMPLATE_NAME_1 && (
              <div ref={componentRef}>
                <div className="mb-4">
                  <TemplateOneFull
                    {...{
                      page: 1,
                      previewImage,
                      milestones,
                      primaryColor,
                      secondaryColor,
                      tertiaryColor,
                      profile,
                      totalPage
                    }}
                    details={moreInfo}
                    personal={state.personal}
                    social={state.social}
                    setTotalPage={setTotalPage}
                    milestone_position = {state.milestone_position}
                  />
                </div>
                {
                // pageContents.length > 1 && ( 
                    showDisplay ? 
                      pageContents.map((item,index)=>{
                        return (
                          <div className="mb-4" key={index}>
                              <TemplateOneFull
                                {...{
                                  item:item,
                                  page: index+2,
                                  previewImage,
                                  milestones,
                                  primaryColor,
                                  secondaryColor,
                                  tertiaryColor,
                                  profile,
                                  mergeMilestone,
                                  totalPage,
                                  show_qr_milestone:state.show_qr_milestone,
                                  show_qr_reels:state.show_qr_reels
                                }}
                                details={moreInfo}
                                personal={state.personal}
                                social={state.social}
                                totalPage={totalPage}
                                milestone_position = {state.milestone_position}
                                
                        />
                          </div>
                        )
                      }) 
                  :
                    // pre-load
                    <div style={A4_SIZE}> 
                      {pageContents.map((pageItems, pageIndex) => (
                        <div className="mb-8 border border-resume-border" key={pageIndex} style={A4_SIZE}> 
                          <div className="w-full flex flex-row h-full overflow-hidden">
                            <LeftContent
                                {...{
                                  previewImage, 
                                  secondaryColor,
                                  tertiaryColor
                                }
                                }
                                details={moreInfo}
                              personal={state.personal}
                              />
                            <div className="w-full h-full bg-white p-8.6 relative"
                            style={{ width: "calc(100% - 308.475px)" }}
                            >
                              {pageItems.map((item, itemIndex) => (
                                <div 
                                  key={`item-${pageIndex}-${itemIndex}`}
                                  ref={el => itemRefs.current[itemIndex] = el}
                                >
                                  <ItemMilestoneClone
                                    items={item}
                                    secondaryColor={secondaryColor}
                                    tertiaryColor={tertiaryColor}
                                    show_image_milestone={state.show_milestone_image}
                                    profile={profile}
                                    // milestone_position={milestone_position}
                                    milestone_position = {state.milestone_position}
                                    fullPreview={true}
                                  />
                                </div>
                              ))}
                              
                              {/* Footer */}
                              <div className="absolute left-0 bottom-0 w-full h-6 border-t px-2 z-50 bg-white"
                                style={{ borderColor: "#DAE4EF" }}>
                                <div className="w-full h-full flex flex-row justify-between items-center">
                                  <p className="font-medium text-1xs text-darkerGray">Page {pageIndex+2}</p>
                                  <div className="flex flex-start gap-1.5">
                                    <button className="w-1.5 h-1.5 rounded-full bg-primary" />
                                    <button className="w-1.5 h-1.5 rounded-full bg-pageInactive" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
            // )
            }
              </div>
            )}
            {state.templateName === TEMPLATE_NAME_2 && (
              <div ref={componentRef}>
                <div className="mb-4">
                  <TemplateTwoFullPageOne
                    {...{
                      previewImage,
                      primaryColor,
                      secondaryColor,
                      tertiaryColor,
                      quarternary,
                      totalPage
                    }}
                    color={state.color}
                    details={moreInfo}
                    personal={state.personal}
                    social={state.social}
                  />
                </div>
                {totalPage > 1 && ( 
                mergeMilestone.map((item,index)=>{
                  return (
                    <div className="mb-4" key={index}>
                        <TemplateTwoFullPageTwo
                        {...{
                          item:item,
                          page: index+2,
                          previewImage,
                          milestones,
                          primaryColor,
                          secondaryColor,
                          tertiaryColor,
                          quarternary,
                          profile,
                          totalPage,
                          show_qr_milestone:state.show_qr_milestone,
                          show_qr_reels:state.show_qr_reels
                        }}
                        color={state.color}
                        social={state.social}
                        milestone_position = {state.milestone_position}
                        show_image_milestone = {state.show_milestone_image}
                      />
                    </div>
                  )
                }) 
            )}
              </div>
            )}
            {state.templateName === TEMPLATE_NAME_3 && (
              <div ref={componentRef}>
                <div className="mb-4">
                  <TemplateThreeFullPageOne
                  {...{
                    previewImage,
                    primaryColor,
                    secondaryColor,
                    tertiaryColor,
                    quarternary,
                    totalPage
                  }}
                  color={state.color}
                  details={moreInfo}
                  personal={state.personal}
                  social={state.social}
                />
                </div>
                {totalPage > 1 && ( 
                mergeMilestone.map((item,index)=>{
                  return (
                    <div className="mb-4" key={index}>
                        <TemplateThreeFullPageTwo
                        {...{
                          item:item,
                          page: index+2,
                          previewImage,
                          milestones,
                          primaryColor,
                          secondaryColor,
                          tertiaryColor,
                          quarternary,
                          profile,
                          totalPage,
                          show_qr_milestone:state.show_qr_milestone,
                          show_qr_reels:state.show_qr_reels
                        }}
                        color={state.color}
                        social={state.social}
                        show_image_milestone = {state.show_milestone_image}
                        milestone_position = {state.milestone_position}
                        totalPage={totalPage}
                      />
                    </div>
                  )
                }) 
            )}
              </div>
            )}
            {state.templateName === TEMPLATE_NAME_4 && (
              <div ref={componentRef}>
              <div className="mb-4">
                <TemplateFourFullPageOne
                  {...{
                    previewImage,
                    primaryColor,
                    secondaryColor,
                    tertiaryColor,
                    quarternary,
                    totalPage
                  }}
                  color={state.color}
                  details={moreInfo}
                  personal={state.personal}
                  social={state.social}
                  totalPage={totalPage}
                />
              </div>
              {totalPage > 1 && ( 
                mergeMilestone.map((item,index)=>{
                  return (
                    <div className="mb-4" key={index}>
                        <TemplateFourFullPageTwo
                        {...{
                          item:item,
                          page: index+2,
                          previewImage,
                          milestones,
                          primaryColor,
                          secondaryColor,
                          tertiaryColor,
                          quarternary,
                          profile,
                          totalPage,
                          show_qr_milestone:state.show_qr_milestone,
                          show_qr_reels:state.show_qr_reels
                        }}
                        color={state.color}
                        social={state.social}
                        show_image_milestone = {state.show_milestone_image}
                        totalPage={totalPage}
                        milestone_position = {state.milestone_position}
                      />
                    </div>
                  )
                }) 
            )}
              </div>
            )}

            {state.templateName === TEMPLATE_NAME_5 && (
              <div className="h-full mb-4" ref={componentRef}>
                <div className="mb-4">
                  <TemplateFiveFullPageOne
                    {...{
                      previewImage,
                      primaryColor,
                      secondaryColor,
                      tertiaryColor,
                      quarternary,
                      totalPage
                    }}
                    color={state.color}
                    details={moreInfo}
                    personal={state.personal}
                    social={state.social}
                    totalPage={totalPage}
                    minHeight="305mm"
                  />
                </div>
                <div className="mb-4" key={2}>
                    <TemplateFiveFullPageTwo
                    {...{
                      page: 2,
                      previewImage,
                      milestones,
                      primaryColor,
                      secondaryColor,
                      tertiaryColor,
                      quarternary,
                      profile,
                      totalPage,
                      show_qr_milestone:state.show_qr_milestone,
                      show_qr_reels:state.show_qr_reels
                    }}
                    color={state.color}
                    social={state.social}
                    show_image_milestone = {state.show_milestone_image}
                    totalPage={totalPage}
                    maxHeight="305mm"
                    personal={{...state.personal,...state.more}}
                    details={moreInfo}
                    milestone_position = {state.milestone_position}
                  />
                </div>
              </div>
            )}
          </div>
        </>
      </div>
    </EmptyLayout>
  );
}


function LoadingModal() {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999]">
      <div className="bg-transparent px-6 py-4 text-center">
        <div className="flex flex-col justify-center items-center my-20 text-white">
            <Lottie animationData={Spinner} className="w-16 h-16 text-white" />
            <p className="text-md font-semibold text-gray-500">Loading...</p>
          </div> 
      </div>
    </div>
  );
}